<div class="host-layout-page">
  <div class="page-header page-header--no-search">
    <div class="page-header__title">
      <h2>{{ 'HOST_LAYOUT_TITLE' | translate }}</h2>
      <p>{{ 'Listen ports and disk paths of this API host.' | translate }}</p>
    </div>
    <div class="header-actions">
      <app-secondary-button
        class="header-actions__refresh"
        title="Refresh"
        icon="refresh"
        [disable]="loading()"
        (action)="load()"
      ></app-secondary-button>
    </div>
  </div>

  @if (errorMessage()) {
    <div class="error-message" role="alert">{{ errorMessage() | translate }}</div>
  }

  @if (loading()) {
    <app-loading [loading]="true"></app-loading>
  } @else if (snapshot()) {
    @if (snapshot(); as layout) {
    <div class="facts">
      <div class="fact">
        <span class="fact__label">{{ 'Environment' | translate }}</span>
        <app-copyable-identifier [value]="layout.environmentName || ''"></app-copyable-identifier>
      </div>
      <div class="fact">
        <span class="fact__label">{{ 'Machine name' | translate }}</span>
        <app-copyable-identifier [value]="layout.machineName || ''"></app-copyable-identifier>
      </div>
      <div class="fact">
        <span class="fact__label">{{ 'Running in container' | translate }}</span>
        <span>{{ (layout.runningInContainer ? 'Yes' : 'No') | translate }}</span>
      </div>
      <div class="fact">
        <span class="fact__label">{{ 'Request host' | translate }}</span>
        <app-copyable-identifier [value]="layout.requestHost || ''"></app-copyable-identifier>
      </div>
      <div class="fact fact--wide">
        <span class="fact__label">{{ 'Content root' | translate }}</span>
        <app-copyable-identifier [value]="layout.contentRoot || ''"></app-copyable-identifier>
      </div>
    </div>

    <div class="orch-table-panel">
      <app-orchestration-table-heading
        heading="Ports and URLs"
        [query]="endpointQuery()"
        (queryChange)="onEndpointQuery($event)"
      ></app-orchestration-table-heading>
      <app-data-table
        [columns]="endpointColumns()"
        [data]="visibleEndpoints()"
        [config]="endpointTableConfig()"
        [totalRecords]="visibleEndpoints().length"
      ></app-data-table>
    </div>

    <div class="orch-table-panel">
      <app-orchestration-table-heading
        heading="Disk paths"
        [query]="pathQuery()"
        (queryChange)="onPathQuery($event)"
      ></app-orchestration-table-heading>
      <app-data-table
        [columns]="pathColumns()"
        [data]="visiblePaths()"
        [config]="pathTableConfig()"
        [totalRecords]="visiblePaths().length"
      ></app-data-table>
    </div>
    }
  }
</div>

<ng-template #displayTemplate let-row>
  <app-copyable-identifier [value]="row.display || ''"></app-copyable-identifier>
</ng-template>
<ng-template #configKeyTemplate let-row>
  <app-copyable-identifier [value]="row.configKey || ''"></app-copyable-identifier>
</ng-template>
<ng-template #pathTemplate let-row>
  <app-copyable-identifier [value]="row.path || ''"></app-copyable-identifier>
</ng-template>
